import React, { useState, useEffect } from 'react';
import { connect } from "react-redux";
import compose from 'recompose/compose';
import { arrayOf, bool, func, string, object } from 'prop-types';
import { withStyles } from '@material-ui/core';

import AddOrganizations from './add.js';
import EditOrganizations from './edit.js';
import styles from './styles';
import { hasCRUDPermissions } from '../../../../utils';
import { PERMISSION_ORGANIZATIONS_PRODUCT, PERMISSION_ORGANIZATION } from '../../../../constants';

export const Organizations = (props) => {
  const {
    productUuid,
    isCurrentTab,
    notifyMessages,
    userContext,
    productDetails,
  } = props;

  const [page, setPage] = useState('edit');
  const hasRead = hasCRUDPermissions(userContext, ['READ'], PERMISSION_ORGANIZATIONS_PRODUCT);
  const hasUpdate = hasCRUDPermissions(userContext, ['UPDATE'], PERMISSION_ORGANIZATIONS_PRODUCT);
  const hasReadOrg = hasCRUDPermissions(userContext, ['READ'], PERMISSION_ORGANIZATION);

  useEffect(() => {
    if (isCurrentTab) {
      if(!hasRead) {
        props.push('/404');
      }
    }
  }, [isCurrentTab, userContext]);

  const onPageChange = (value) => {
    setPage(value)
  }

  return (
    <>
      {page === 'edit' ?
        <EditOrganizations
          productUuid={productUuid}
          isCurrentTab={isCurrentTab}
          onPageChange={onPageChange}
          notifyMessages={notifyMessages}
          hasUpdate={hasUpdate}
          hasReadOrg={hasReadOrg}
          productDetails={productDetails}
        />
      :
        <AddOrganizations
          productUuid={productUuid}
          isCurrentTab={isCurrentTab}
          onPageChange={onPageChange}
          notifyMessages={notifyMessages}
          hasReadOrg={hasReadOrg}
        />
      }
    </>
  )
};

const mapStateToProps = () => ({});

const mapDispatchToProps = {};

Organizations.propTypes = {
  productUuid: string,
  isCurrentTab: bool,
  notifyMessages: func,
  push: func,
  userContext: arrayOf(object),
  errors: arrayOf(object),
  productDetails: object,
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps),
)(Organizations);
